import loadable from '@loadable/component';

export const namespace = 'canalplus.block.form.submission';
export const Component = loadable(() => import('./components/FormSubmission'));
export { default as propsFormatter } from './propsFormatter';
